var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconImage32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 11a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zm0 1.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 5a2.75 2.75 0 012.745 2.582l.005.168V8h.25a2.75 2.75 0 012.75 2.75v14a2.75 2.75 0 01-2.75 2.75h-14A2.75 2.75 0 018 24.75v-.25h-.25a2.75 2.75 0 01-2.745-2.582L5 21.75v-14a2.75 2.75 0 012.582-2.745L7.75 5h14zM23 7.75V8H10.75A2.75 2.75 0 008 10.75V23h-.25l-.128-.006A1.25 1.25 0 016.5 21.75v-14l.006-.128A1.25 1.25 0 017.75 6.5h14l.128.006A1.25 1.25 0 0123 7.75zM10.75 9.5h14c.69 0 1.25.56 1.25 1.25v10.53l-3.651-4.033-.083-.08a.75.75 0 00-1.001.05l-4.583 4.543-3.48-2.623-.094-.06a.75.75 0 00-.89.13L9.5 21.934V10.75c0-.69.56-1.25 1.25-1.25zM9.5 24.06v.69c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-1.236l-4.236-4.679-4.486 4.448a.75.75 0 01-.887.126l-.093-.06-3.478-2.622L9.5 24.06z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage32);
export default __webpack_public_path__ + "static/media/icon-image-32.0e399eba.svg";
export { ForwardRef as ReactComponent };